module.exports = __webpack_public_path__ + "img/face-smile-hearts.7ac91e9e.svg";